import { ReactNode } from 'react'
import { Tooltip } from '@base-ui/react/tooltip'
import { TooltipPositioner } from './positioner'
import { TooltipPopup } from './popup'

interface TooltipContentProps extends Pick<
  Tooltip.Positioner.Props,
  'side' | 'sideOffset' | 'align' | 'alignOffset' | 'collisionAvoidance'
> {
  className?: string
  children: ReactNode
  positionerClassName?: string
}

function TooltipContent({
  className,
  children,
  side,
  sideOffset,
  align,
  alignOffset,
  collisionAvoidance,
  positionerClassName,
}: TooltipContentProps) {
  return (
    <Tooltip.Portal>
      <TooltipPositioner
        className={positionerClassName}
        side={side}
        sideOffset={sideOffset}
        align={align}
        alignOffset={alignOffset}
        collisionAvoidance={collisionAvoidance}
      >
        <TooltipPopup className={className}>{children}</TooltipPopup>
      </TooltipPositioner>
    </Tooltip.Portal>
  )
}

export { TooltipContent }
